// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".foryou-content[data-v-e711e500] {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n.foryou-content .video-content[data-v-e711e500] {\n  width: 38.54167vw;\n}\n.foryou-video-swiper[data-v-e711e500] {\n  position: absolute;\n  top: 0;\n  background: #000;\n  z-index: 9999;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
